module.exports = __webpack_public_path__ + "img/icon-2.d1fac490.png";